import React from 'react';
var SelectableContext = React.createContext();
export var makeEventKey = function makeEventKey(eventKey, href) {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
export default SelectableContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/esm/SelectableContext.js
// module id = 87
// module chunks = 0